import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  requestStudentOnboardEvents,
  receiveStudentOnboardEvents,
  handleStudentOnboardEventsError,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_ONBOARD_EVENTS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_ONBOARD_EVENTS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_ONBOARD_EVENTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchStudentOnboardEvents = student_uuid => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentOnboardEvents());
  try {
    return fetch(
      `${API.student.student_onboard_events}?student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentOnboardEvents(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentOnboardEventsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentOnboardEventsError(err));
  }
};
